import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import ReactLoading from 'react-loading';

import api from '../../services/api';
import { URL } from '../../constants/index';
import LogoBranco from '../../assets/LogoBranco.png';

import '../Login/styles.css';

const RecuperarSenha = () => {
  const [email, setEmail] = useState('');
  const [erroSenha, setErroSenha] = useState('');
  const [sucessoSenha, setSucessoSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const onRetornarLogin = () => history.push(URL.URLLogin);
  
  const loadingStatus = (status) => setLoading(status);

  const handleRecuperarSenha = (e) => {
    e.preventDefault();
    if (!validarFormulario()) return;

    loadingStatus(true);
    api.post('/api/login/recuperarsenha', { email }, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(res => {
        tratarSucessoRecuperarSenha();
        loadingStatus(false);
      })
      .catch(err => {
        loadingStatus(false);
        if (err.response && err.response.data) {
          tratarErroRecuperarSenha(err.response.data.message);
        } else {
          tratarErroRecuperarSenha('Erro ao se comunicar com a API');
        }
      });
  };

  const tratarSucessoRecuperarSenha = () => {
    setSucessoSenha('E-mail com instruções foi enviado com sucesso');
    setErroSenha('');
  };

  const validarFormulario = () => {
    if (!email) {
      tratarErroRecuperarSenha('Preencha o e-mail para continuar');
      return false;
    }
    return true;
  };

  const tratarErroRecuperarSenha = (erro) => {
    setErroSenha(erro);
    setSucessoSenha('');
  };

  return (
    <div className="login-container">
      <div className="login-visual">
        <div className="visual-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
          <div className="shape shape-4"></div>
        </div>
        <div className="visual-content">
          <img src={LogoBranco} alt="PWI Sistemas" className="login-logo-large" />
          <h1 className="visual-title">VolpeBI</h1>
        </div>
      </div>

      <div className="login-form-section">
        <div className="login-form-wrapper">
          <div className="login-header">
            <h2>Recuperar Senha</h2>
            <p>Informe seu e-mail para redefinir sua senha</p>
          </div>

          <form onSubmit={handleRecuperarSenha} className="login-form">
            {erroSenha && (
              <div className="login-error-alert">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
                <span>{erroSenha}</span>
              </div>
            )}
            
            {sucessoSenha && (
              <div className="login-error-alert" style={{backgroundColor: '#f0fdf4', color: '#166534', borderLeftColor: '#22c55e'}}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
                <span>{sucessoSenha}</span>
              </div>
            )}

            <div className="login-input-group">
              <label htmlFor="email">E-mail</label>
              <div className="input-wrapper">
                <svg className="input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                <input
                  id="email"
                  type="email"
                  placeholder="Seu endereço de e-mail"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </div>

            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? (
                 <ReactLoading type="bubbles" color="#ffffff" height={24} width={40} className="loading-indicator" />
              ) : 'Redefinir Senha'}
            </button>
          </form>

          <div className="login-actions" style={{justifyContent: 'center'}}>
            <button type="button" className="btn-secondary" onClick={onRetornarLogin} style={{maxWidth: '200px'}}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>
              Voltar ao Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecuperarSenha;
